/* DESKIZO Review screenshots slider: one dot per page of visible slides, arrows step a page. */
if (!customElements.get('deskizo-review-slider')) {
  customElements.define(
    'deskizo-review-slider',
    class DeskizoReviewSlider extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        this.dotsEl = this.querySelector('[data-dots]');
        this.prev = this.querySelector('[data-prev]');
        this.next = this.querySelector('[data-next]');
        if (!this.track || !this.dotsEl) return;

        this.prev.addEventListener('click', () => this.goTo(this.page - 1));
        this.next.addEventListener('click', () => this.goTo(this.page + 1));
        this.track.addEventListener('scroll', () => {
          clearTimeout(this.t);
          this.t = setTimeout(() => this.update(), 60);
        }, { passive: true });
        this.resizeObserver = new ResizeObserver(() => this.build());
        this.resizeObserver.observe(this.track);
        this.build();
      }

      disconnectedCallback() {
        this.resizeObserver?.disconnect();
      }

      build() {
        const slide = this.track.children[0];
        if (!slide) return;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        this.step = slide.getBoundingClientRect().width + gap;
        this.perView = Math.max(1, Math.round((this.track.clientWidth + gap) / this.step));
        this.count = Math.max(1, Math.ceil(this.track.children.length / this.perView));
        this.dotsEl.replaceChildren(
          ...Array.from({ length: this.count }, (_, i) => {
            const b = document.createElement('button');
            b.type = 'button';
            b.className = 'dz-rs__dot';
            b.setAttribute('aria-label', `${i + 1} / ${this.count}`);
            b.addEventListener('click', () => this.goTo(i));
            return b;
          })
        );
        this.dotsEl.parentElement.hidden = this.count < 2;
        this.update();
      }

      goTo(i) {
        const page = Math.min(Math.max(i, 0), this.count - 1);
        this.track.scrollTo({ left: page * this.perView * this.step, behavior: 'smooth' });
      }

      update() {
        const max = this.track.scrollWidth - this.track.clientWidth;
        this.page = max <= 2 ? 0 : Math.round(this.track.scrollLeft / (this.perView * this.step));
        if (this.track.scrollLeft >= max - 2) this.page = this.count - 1;
        Array.from(this.dotsEl.children).forEach((d, i) => d.setAttribute('aria-current', String(i === this.page)));
        this.prev.disabled = this.page <= 0;
        this.next.disabled = this.page >= this.count - 1;
      }
    }
  );
}
